import {
    commitMutation,
    graphql
} from 'react-relay'
import environment from '../../Environment'


const mutation = graphql`
    mutation DeleteTaskStatusMutation($id: String!) {
        deleteTaskStatus(id:$id) {
            id
      }
    }
  `

export default (id, callback) => {
    const variables = {
        id
    }

    commitMutation(
        environment,
        {
            mutation,
            variables,
            onCompleted: (response) => {
                callback({ status: 'OK', pyload: response.deleteTaskStatus })
            },
            onError: err => callback({ status: 'KO', message: err })
        },
    )
}